<div class="row is-mobile is-flex margin-bottom--base" role="search">
    <!-- search field -->
    <div
        [ngClass]="{
            column: true,
            'full-width': !showFilter,
            'is-flex flex-streched': showFilter
        }">
        <riege-search-field
            class="community-listing__search"
            [searchTerm]="searchTerm"
            (searchChanged)="search($event)"></riege-search-field>
    </div>

    <!-- filter button to show filter sidebar -->
    <div class="column" *ngIf="showFilter">
        <riege-filter-button [count]="count" [filterConfig]="filterConfig"></riege-filter-button>
    </div>
</div>

<!-- filter chips -->
<div class="row" *ngIf="showSettings && filterConfig">
    <div class="column riege-filter" *ngIf="filterConfig.filter.countryCode">
        <h3 i18n="@@filter-label-country">Country</h3>
        <mat-chip-listbox aria-label="Country selection" i18n-aria-label="@@aria-label-country-selection">
            <mat-chip-option>
                {{ filterConfig.filter.countryCode | regionName }}
                <button
                    matChipRemove
                    aria-label="Remove"
                    i18n-aria-label="@@aria-label-remove"
                    (click)="removeFilter('countryCode')">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>

    <div class="column riege-filter" *ngIf="selectedServices.length">
        <h3 i18n="@@filter-label-services">Services</h3>
        <mat-chip-listbox aria-label="Service selection" i18n-aria-label="@@aria-label-service-selection">
            @for (service of serviceDefs; track service; let i = $index) {
                <mat-chip-option *ngIf="selectedServices.includes(service.id)">
                    {{ service.text }}
                    <button
                        matChipRemove
                        aria-label="Remove"
                        i18n-aria-label="@@aria-label-remove"
                        (click)="removeFilter(service.id)">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-option>
            }
        </mat-chip-listbox>
    </div>
</div>
